// todo: ...rest instead
export default function keyMetrics() {
  var args = Array.prototype.slice.call(arguments);
  return { metrics: args.join(',') };
};
